import React from "react";
import { format } from "date-fns";
import { IconButton } from "@mui/material";
import { BookingDetails } from "../../@types/Booking/bookingDetails";
import { MdOutlineModeEdit } from "react-icons/md";
interface BookingSummaryNavbarProps {
  bookingDetails: BookingDetails;
  onEdit: () => void;
}

function BookingSummaryNavbar({
  bookingDetails,
  onEdit,
}: BookingSummaryNavbarProps): JSX.Element {
  const formatDateTime = (date: number | Date) => {
    try {
      return format(new Date(date), "d MMM | HH:mm");
    } catch {
      return "";
    }
  };

  const pickUpFormatted = formatDateTime(bookingDetails.pickUpDateAndTime);
  const dropOffFormatted = formatDateTime(bookingDetails.dropOffDateAndTime);

  return (
    <div className="w-full bg-black flex items-center justify-center py-4 px-4 sticky top-0 z-50">
      <div className="flex items-center justify-between bg-[#333333] rounded-full px-6 py-2 w-full max-w-2xl">
        <div className="flex flex-col text-white flex-1">
          <span className="font-semibold text-sm leading-tight">
            {bookingDetails.pickUpLocationName} -{" "}
            {bookingDetails.dropOffLocationName}
          </span>
          <span className="text-xs text-gray-300 mt-0.5">
            {pickUpFormatted} - {dropOffFormatted}
          </span>
        </div>
        <IconButton
          onClick={onEdit}
          size="small"
          sx={{
            color: "white",
            ml: 1,
            padding: "6px",
          }}
        >
          {React.createElement(MdOutlineModeEdit as React.ElementType, {
            size: 16,
            color: "white",
          })}
        </IconButton>
      </div>
    </div>
  );
}

export default BookingSummaryNavbar;
